module.exports = __webpack_public_path__ + "img/5_gender_equality.1990aef8.svg";